export default {"src":"/_next/static/media/raspberries.6ece889c.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};